(function ($) {
  $(document).on('click', '[data-modal="#contact-form"]', function (e) {
    e.preventDefault();
    var tid = $(this).data('residenceTypeId');
    var tidAttr = $(this).attr('data-residence-type-id');
    var attempts = 0;
    var maxAttempts = 50;
    var interval = setInterval(function () {
      attempts++;
      var $select = $('#contact-form select[name="type_of_residence"]');
      if ($select.length) {
        $select.val(tid || tidAttr).trigger('change');
        clearInterval(interval);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 100);
  });
}(jQuery));
